const apiUrl = process.env.REACT_APP_API_URL;

export async function GetUsuarisRecompensesProblema(idProblema: string, idActivitat?: string, origenTipo?: string) {
    let url = `${apiUrl}:8061/jutge/problema/${idProblema}/recompenses/usuaris`;
    const params = new URLSearchParams();
    if (idActivitat && idActivitat !== 'undefined') {
        params.append('id_activitat', idActivitat);
    }
    if (origenTipo) {
        params.append('origen_tipo', origenTipo);
    }
    const query = params.toString();
    if (query) {
        url += `?${query}`;
    }
    try {
        const response = await fetch(url, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('authToken')}`
            }
        });
        if (!response.ok) return [];
        return await response.json();
    } catch (e) {
        return [];
    }
}
